import { PropsWithChildren } from 'react';

type ProjectSecondaryMenuProps = PropsWithChildren;

export const ProjectSecondaryMenu = (props: ProjectSecondaryMenuProps) => {
  return (
    <div className="flex h-full">
      <div className="w-2 flex-shrink-0 bg-white-4" />
      <div className="flex h-full w-[300px] flex-col border-r border-black-20">
        {props.children}
      </div>
    </div>
  );
};
